import { SheetJSFT } from "../../../constant";
import { useComponent, useElement, useService } from "../../../hooks";
import { useImportProducts } from "./hooks";

export const ImportProducts = () => {
  const { getLocationData } = useService("Router");
  const Button = useElement("Button");
  const Link = useElement("Link");
  const Input = useElement("Input");
  const Table = useComponent("Table");
  const Box = useComponent("Box");
  const {
    trackScrolling,
    fileSelected,
    fileImported,
    processProducts,
    handleFile,
    handleChange,
    showTable,
    tableContent,
    activeShownTotal,
    importDone,
  } = useImportProducts();

  return (
    <div id="content-box" className="content" onScroll={trackScrolling}>
      {fileSelected ? (
        <>
          {fileImported ? (
            <>
              {!importDone && (
                <Button
                  type="submit"
                  className="btn btn-primary mv20"
                  onClick={processProducts}
                >
                  Import
                </Button>
              )}
            </>
          ) : (
            <Button
              type="submit"
              className="btn btn-primary mv20"
              onClick={handleFile}
            >
              Parse
            </Button>
          )}
        </>
      ) : (
        <Box title="Import Excel to Add Products">
          <Input
            type="file"
            className="hidden form-control inputfile-1"
            id="file"
            accept={SheetJSFT}
            onChange={handleChange}
          />
          <label className="btn btn-primary" htmlFor="file">
            <i className="hi-upload-cloud"></i>
            <span>Choose a file…</span>
          </label>
        </Box>
      )}
      {showTable ? (
        <Table
          className="import-table"
          data={tableContent}
          pageSize={activeShownTotal}
        />
      ) : (
        importDone && (
          <>
            <p>All Products imported successfully</p>
            <div className="flex">
              <Link className="btn btn-primary" href="/admin/product/list/">
                Back to Products List
              </Link>
              <Button
                className="btn btn-outline ml20"
                onClick={() => getLocationData().reload()}
              >
                Import More
              </Button>
            </div>
          </>
        )
      )}
    </div>
  );
};
